import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: {
    type: "labeled_diagram";
    title?: string;
    description?: string;
    parts: { icon?: string; label: string; detail: string }[];
    animation?: string;
  };
}

export function ElementLabeledDiagram({ data }: Props) {
  const parts = data.parts ?? [];
  return (
    <motion.div
      className="space-y-3"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {data.title && <p className="font-semibold text-slate-800"><MathRichText text={data.title} /></p>}
      {data.description && <p className="text-slate-600 text-sm"><MathRichText text={data.description} /></p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {parts.map((part, i) => (
          <motion.div
            key={i}
            className="flex gap-2 p-3 rounded-lg border-2 border-slate-200 bg-white"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.06 }}
          >
            {part.icon && <span className="text-xl shrink-0">{part.icon}</span>}
            <div>
              <p className="font-medium text-slate-800 text-sm"><MathRichText text={part.label} /></p>
              <p className="text-slate-600 text-xs mt-0.5"><MathRichText text={part.detail} /></p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
